export const isMobile: () => boolean = () => window.screen.width <= 800;
export const isSmallerView: () => boolean = () => window.screen.width <= 1024;
